











import { MeasureTypeEnum, RepeatFrequencyEnum } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({ })
export default class MeasureTypeSelect extends Vue {

    get items() {
        return [
            { id: MeasureTypeEnum.Corrective, name: this.$i18n.t("workTask.findingItem.corrective") },
            { id: MeasureTypeEnum.Preventive, name: this.$i18n.t("workTask.findingItem.preventive") }
        ];
    }

    @Prop({ default: "" }) label!: string;
    @VModel() innerValue!: string;
    @Prop({ default: false }) mandatory!: boolean;
    
}
